export const photos = [
    {
        src: "https://kazcha50.info/gallery//_0010_IMG_0617.jpg",
        width: 4,
        height: 3
    },
    {
      src: "https://kazcha50.info/gallery//_0000_IMG_0747.jpg",
      width: 4,
      height: 3
    },
    {
      src: "https://kazcha50.info/gallery//_0001_IMG_0731.jpg",
      width: 1,
      height: 1
    },
    {
      src: "https://kazcha50.info/gallery//_0002_IMG_0725.jpg",
      width: 3,
      height: 4
    },
    {
      src: "https://kazcha50.info/gallery//_0003_IMG_0721.jpg",
      width: 3,
      height: 4
    },
    {
      src: "https://kazcha50.info/gallery//_0004_IMG_0698.jpg",
      width: 3,
      height: 4
    },
    {
      src: "https://kazcha50.info/gallery//_0005_IMG_0678.jpg",
      width: 4,
      height: 3
    },
    {
      src: "https://kazcha50.info/gallery//_0006_IMG_0639.jpg",
      width: 3,
      height: 4
    },
    {
      src: "https://kazcha50.info/gallery//_0007_IMG_0623.jpg",
      width: 4,
      height: 3
    },
    {
      src: "https://kazcha50.info/gallery//_0008_IMG_0620.jpg",
      width: 4,
      height: 3
    },
    {
        src: 'https://kazcha50.info/gallery//_0001_IMG_0713.jpg',
        width: 4,
        height: 3
    },
    {
        src: "https://kazcha50.info/gallery//_0002_IMG_0705.jpg",
        width: 4,
        height: 3
      },
      {
        src: "https://kazcha50.info/gallery//_0000_IMG_0680.jpg",
        width: 4,
        height: 3
      },
      {
          src: 'https://kazcha50.info/gallery//_0009_IMG_0779.jpg',
          width: 4,
          height: 3
      }
  
  ];
  